import { Controller } from "@hotwired/stimulus";
import { connectStorageScope } from "../base_path";

const MODES = ["light", "dark"];

// Public-page light/dark switch. The brand kit's mode seeds the first visit;
// a visitor choice is then remembered per Connect host without changing the
// agent's saved branding or making the CDN-cached page visitor-specific.
export default class extends Controller {
  static targets = ["label", "toggle"];

  connect() {
    const saved = this.readStoredMode();
    if (MODES.includes(saved)) document.documentElement.dataset.connectMode = saved;
    this.render();
  }

  toggle() {
    const current = this.currentMode();
    const next = current === "dark" ? "light" : "dark";
    const root = document.documentElement;

    root.classList.add("ss-c-mode-anim");
    root.dataset.connectMode = next;
    this.storeMode(next);
    this.render();

    window.clearTimeout(this.animationTimer);
    this.animationTimer = window.setTimeout(() => root.classList.remove("ss-c-mode-anim"), 350);
  }

  disconnect() {
    window.clearTimeout(this.animationTimer);
  }

  currentMode() {
    return document.documentElement.dataset.connectMode === "dark" ? "dark" : "light";
  }

  render() {
    const dark = this.currentMode() === "dark";
    if (this.hasLabelTarget) this.labelTarget.textContent = dark ? "LIGHT MODE" : "DARK MODE";
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-pressed", dark ? "true" : "false");
      this.toggleTarget.setAttribute("aria-label", dark ? "Switch to light mode" : "Switch to dark mode");
    }
  }

  storageKey() {
    return `ssc_mode:${connectStorageScope()}`;
  }

  readStoredMode() {
    try {
      return window.localStorage.getItem(this.storageKey());
    } catch (_error) {
      return null;
    }
  }

  storeMode(mode) {
    try {
      window.localStorage.setItem(this.storageKey(), mode);
    } catch (_error) {
      // Storage can be unavailable in private browsing; the toggle still works.
    }
  }
}
